import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../context/AuthContext.jsx";
import logoImg from "../Images/logo40.jpg";
import "./LogIn.css";

export default function LoginForm() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { login } = useAuth();

  const [loginField, setLoginField] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      const artist = await login(loginField.trim(), password);
      navigate(`/ArtistProfile/${artist._id}`);
    } catch (err) {
      setError(
        err.response?.data?.error === "Invalid credentials"
          ? t("login.error")
          : t("error.generic")
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <div className="spar-card login-card">
        <div className="login-brand">
          <img src={logoImg} alt="SPAR" className="login-logo" />
          <h1 className="spar-page-title">{t("login.title")}</h1>
          <p className="login-subtitle">{t("login.subtitle")}</p>
        </div>

        {error && (
          <div className="spar-alert spar-alert-error">{error}</div>
        )}

        <form onSubmit={handleSubmit} noValidate>
          <div className="spar-form-group">
            <label className="spar-label" htmlFor="login-email">
              {t("login.email")}
            </label>
            <input
              id="login-email"
              type="text"
              className="spar-input"
              value={loginField}
              onChange={(e) => setLoginField(e.target.value)}
              required
              autoComplete="username"
              placeholder="email or username"
            />
          </div>

          <div className="spar-form-group">
            <label className="spar-label" htmlFor="login-password">
              {t("login.password")}
            </label>
            <div className="pw-wrap">
              <input
                id="login-password"
                type={showPw ? "text" : "password"}
                className="spar-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />
              <button
                type="button"
                className="pw-eye"
                onClick={() => setShowPw(s => !s)}
                aria-label={showPw ? "Hide password" : "Show password"}
              >
                {showPw ? "🙈" : "👁"}
              </button>
            </div>
          </div>

          <button
            type="submit"
            className="spar-btn spar-btn-primary"
            disabled={submitting}
            style={{ width: "100%", justifyContent: "center", height: 48 }}
          >
            {submitting ? (
              <>
                <span className="spar-spinner" />
                {t("login.submitting")}
              </>
            ) : (
              t("login.submit")
            )}
          </button>
        </form>

        <p style={{ textAlign: "center", marginTop: 8, fontSize: "0.9rem" }}>
          <a href="/forgot-password" style={{ opacity: 0.75 }}>
            {t("login.forgotPassword")}
          </a>
        </p>

        <p className="login-footer-text">
          {t("login.noAccount")}{" "}
          <a href="/signup" style={{ fontWeight: 700 }}>
            {t("login.signupLink")}
          </a>
        </p>
      </div>
    </div>
  );
}
